export default function getAllowedPolicyEffectDate(type) {
  if (type === 'min') {
    const dt = new Date();
    return dt.toISOString().split('T')[0];
  }
  const dt = new Date();
  dt.setMonth(dt.getMonth() + 1);
  return dt.toISOString().split('T')[0];
}
